// Fonts now handled via CSS imports in index.css
// import { Fira_Code as FontMono, Space_Grotesk } from "next/font/google";

// Font variables for CSS usage
export const fontSans = {
  variable: "--font-sans",
};

export const fontMono = {
  variable: "--font-mono",
};
